function Footer(props) {
    return (
      <div className="footer footerGrid">
        <img className="qr" src="https://thumbs2.imgbox.com/4f/72/UXeXfMcK_t.png" alt="Freesource Library QR code"/>
        <h6 className="footerMsg" >Freesource Library made possible by Kaye B. Designing and contributions from content creators around the world.</h6>
      </div>
    );
  }
  
  export default Footer;